import React from "react";
import PlutosHome from "./plutosHome/plutosHome";
import External from "./external/external";

const BodyCreation = (props) => {
  const { handleNext, activeStep, handleBack } = props;
  const uiType = localStorage.getItem("uiType");

  return (
    <div>
      {uiType === "plutoshome" ? (
        <PlutosHome
          handleNext={handleNext}
          handleBack={handleBack}
          activeStep={activeStep}
        />
      ) : (
        <External
          handleNext={handleNext}
          handleBack={handleBack}
          activeStep={activeStep}
        />
      )}
    </div>
  );
};

export default BodyCreation;
